import { useTranslation } from 'react-i18next';
import { Glyphicon } from 'react-bootstrap';
import SectionHeader from 'components/sectionHeader/SectionHeader';
import Button from 'components/button/Button';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import useOpenDirectBookingReviewModal from './modals/useOpenDirectBookingReviewModal';

const DirectBookingReviewsSectionHeader = () => {
  const { openCreateModal } = useOpenDirectBookingReviewModal();
  const { t } = useTranslation();

  return (
    <SectionHeader
      id="direct-booking-reviews-section"
      title={t('pageProperty.reviews.directBooking.header.title')}
      subtitle={t('pageProperty.reviews.directBooking.header.subtitle')}
      buttons={
        <PropertyEditActionWrapper tooltipId="direct-booking-reviews-section-button-tooltip">
          <Button
            bsStyle="primary"
            data-testid="direct-booking-reviews-section-button"
            onClick={openCreateModal}
          >
            <Glyphicon glyph="plus" />
            {t('pageProperty.reviews.directBooking.header.addReview')}
          </Button>
        </PropertyEditActionWrapper>
      }
    />
  );
};

export default DirectBookingReviewsSectionHeader;
